import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlane,
  faTruck,
  faCheckCircle,
  faLock
} from "@fortawesome/free-solid-svg-icons";
import styles from "./banner.module.scss";

const Banner = () => {
  const features = [
    {
      value: "Free shipping",
      icon: faPlane
    },
    {
      value: "Worry-free returns",
      icon: faTruck
    },
    {
      value: "Money back guarantee",
      icon: faCheckCircle
    },
    {
      value: "Safe payments",
      icon: faLock
    }
  ];

  return (
    <div className={styles.banner}>
      <div className={styles.bannerContent}>
        {features.map((feature, i) => (
          <React.Fragment key={feature.value}>
            {i !== 0 && <div className={styles.line} />}
            <div className={styles.feature}>
              <i>
                <FontAwesomeIcon icon={feature.icon} />
              </i>
              <h4>{feature.value}</h4>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Banner;
